export const API_HOST = 'https://staging.chefami.com';
export const environment = {
  production: false,
  recipeImagePath: `${API_HOST}/img/recipe/`,
  getSiteData: `${API_HOST}/api/fetch-site-data`,
  getRecipeList: `${API_HOST}/api/get-all-recipes`,
  getNewToken: `${API_HOST}/api/get-new-token`,
  cookieDomain: '.chefami.com',
  maintainence: `${API_HOST}/maintenance.php`,
};
